export default __webpack_public_path__ + "static/media/TV3.65941f23.jpg";